export const email = {
    USER_ID: process.env.REACT_APP_USER_ID,
    TEMPLATE_ID: process.env.REACT_APP_TEMPLATE_ID,
}